/**
 * The team behind the Quality Co-Pilot door (kanban 16a22d06).
 *
 * GET /quality-copilot/team returns the Sigma team's definition and mandate
 * areas straight from the roadmap's team-mandate registry — the door keeps
 * no copy of its own, so an admin edit on /roadmap (Ravi's definition, PJ's
 * amendments) is the only edit. Uses the shared axios instance like
 * qcpInvestigations.ts.
 */
import api from './api';

const BASE = '/quality-copilot';

export interface DoorTeamAreaRead {
  key: string;
  title: string;
  description: string;
}

export interface DoorTeamBriefRead {
  team: string;
  /** The team's high-level definition in the group's words; null = not written yet. */
  definition: string | null;
  areas: DoorTeamAreaRead[];
  /** Where this version came from (Jess's outline, Ravi's email, an admin). */
  basis: string | null;
  set_by_email: string;
  set_at: string;
}

/** The door's team, or null when it is not registered on the roadmap (404). */
export async function getDoorTeam(): Promise<DoorTeamBriefRead | null> {
  try {
    const { data } = await api.get<DoorTeamBriefRead>(`${BASE}/team`);
    return data;
  } catch (err) {
    const status = (err as { response?: { status?: number } })?.response?.status;
    if (status === 404) return null;
    throw err;
  }
}
